// Route table + providers. Owner: integration lead (WP00). Page contents belong to their feature owners.
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PlayerProvider } from '../features/player/index.tsx';
import Shell from './Shell.tsx';
import { CatalogSync } from './session.ts';

const HomePage = lazy(() => import('../features/home/HomePage.tsx'));
const LivePage = lazy(() => import('../features/live/LivePage.tsx'));
const SetupPage = lazy(() => import('../features/setup/SetupPage.tsx'));
const SettingsPage = lazy(() => import('../features/settings/SettingsPage.tsx'));
const MoviesPage = lazy(() => import('../features/movies/MoviesPage.tsx'));
const MovieDetailPage = lazy(() => import('../features/movies/MovieDetailPage.tsx'));
const SeriesPage = lazy(() => import('../features/series/SeriesPage.tsx'));
const SeriesDetailPage = lazy(() => import('../features/series/SeriesDetailPage.tsx'));
const MyTvPage = lazy(() => import('../features/mytv/MyTvPage.tsx'));
const SearchPage = lazy(() => import('../features/search/SearchPage.tsx'));
const MultiviewPage = lazy(() => import('../features/multiview/MultiviewPage.tsx'));
const LicensesPage = lazy(() => import('../features/settings/LicensesPage.tsx'));

export const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } } });

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PlayerProvider>
          <CatalogSync />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/setup" element={<SetupPage />} />
              <Route element={<Shell />}>
                <Route index element={<HomePage />} />
                <Route path="live" element={<LivePage />} />
                <Route path="live/:tab" element={<LivePage />} />
                <Route path="movies" element={<MoviesPage />} />
                <Route path="movies/:id" element={<MovieDetailPage />} />
                <Route path="series" element={<SeriesPage />} />
                <Route path="series/:id" element={<SeriesDetailPage />} />
                <Route path="mytv" element={<MyTvPage />} />
                <Route path="search" element={<SearchPage />} />
                <Route path="multiview" element={<MultiviewPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="settings/licenses" element={<LicensesPage />} />
                <Route path="*" element={<HomePage />} />
              </Route>
            </Routes>
          </Suspense>
        </PlayerProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
